var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShortGoalsPlaceholder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 139,
    viewBox: "0 0 174 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1247_4667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.698 139C142.865 139 174 107.78 174 69.4938C174 31.2074 142.865 0 104.698 0C66.5303 0 35.3936 31.2198 35.3936 69.4917C35.3936 107.764 66.5283 138.998 104.698 138.998V139Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.698 125.875C135.663 125.875 160.928 100.556 160.928 69.4916C160.928 38.4271 135.663 13.1079 104.698 13.1079C73.7326 13.1079 48.4679 38.4416 48.4679 69.4916C48.4679 100.542 73.7305 125.875 104.698 125.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.698 113.428C128.826 113.428 148.498 93.6885 148.498 69.4939C148.498 45.2993 128.824 25.572 104.698 25.572C80.5713 25.572 60.8958 45.2993 60.8958 69.4939C60.8958 93.6885 80.5692 113.428 104.698 113.428Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.698 99.7008C121.288 99.7008 134.808 86.1289 134.808 69.4917C134.808 52.8546 121.288 39.2971 104.698 39.2971C88.1081 39.2971 74.5856 52.8691 74.5856 69.4917C74.5856 86.1144 88.1081 99.7008 104.698 99.7008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2309 65.1507L126.261 42.4307C126.765 42.2195 127.354 42.4597 127.564 42.9796L137.848 67.5677C138.059 68.0731 137.821 68.6633 137.315 68.8746L83.2853 91.5946C82.7813 91.8058 82.1926 91.5656 81.9675 91.0602L71.6981 66.4721C71.4729 65.9523 71.727 65.362 72.2309 65.1507Z",
    fill: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.0338 66.2049L125.043 45.1852C125.476 45.003 125.98 45.2142 126.164 45.6492L134.963 66.6957C135.145 67.1306 134.948 67.6381 134.515 67.8203L84.506 88.8544C84.0722 89.0367 83.5662 88.8254 83.3844 88.3905L74.5711 67.3295C74.3894 66.8945 74.598 66.3892 75.0338 66.2049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.614 64.8275L100.676 57.2411L118.751 49.6401C118.795 49.781 118.85 49.9218 118.906 50.0626C120.476 53.8279 124.272 55.81 127.383 54.5031C127.579 54.4182 127.761 54.3353 127.942 54.2359L130.016 59.1962C129.82 59.2521 129.624 59.3225 129.427 59.393C126.317 60.6998 125.069 64.8172 126.639 68.5679C126.709 68.7088 126.765 68.8496 126.835 68.9904L108.775 76.5769L90.7002 84.1779C90.6569 84.037 90.6011 83.8817 90.5453 83.7429C88.9756 79.9922 85.1793 78.0101 82.0687 79.317C81.8725 79.3874 81.6907 79.4847 81.509 79.5841L79.4352 74.6239C79.6315 74.5679 79.8277 74.4975 80.0239 74.4271C83.1345 73.1057 84.382 69.0029 82.8123 65.2521C82.742 65.1113 82.6863 64.9704 82.616 64.8317L82.614 64.8275Z",
    fill: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.701 75.5207L109.657 74.2843L109.167 73.0892C110.555 71.8259 111.13 69.8707 110.401 68.1289C109.994 67.1597 109.293 66.4286 108.383 65.9791C107.191 65.3744 105.679 65.2915 104.291 65.8673C103.702 66.12 103.043 65.8818 102.82 65.333C102.597 64.7841 102.876 64.1379 103.465 63.8852C104.053 63.6326 104.739 63.8852 104.964 64.4341L108.271 63.0423C107.556 61.315 105.764 60.3457 103.886 60.4576L103.297 59.0658L100.34 60.3167L100.899 61.6505C99.3586 62.9015 98.77 64.9519 99.5135 66.7372C100.451 68.9864 103.143 69.9702 105.58 68.9429C106.168 68.6902 106.854 68.9429 107.079 69.4772C107.304 70.0261 106.995 70.6702 106.406 70.9249C105.817 71.1631 105.158 70.9394 104.921 70.3761L101.6 71.7658C102.37 73.636 104.262 74.6032 106.224 74.394L106.701 75.5186V75.5207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4523 9.10449L41.0963 20.9761L41.9659 40.0012L27.6316 52.492L0 40.6184L14.3198 28.1296L13.4523 9.10449Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2496 25.866L105.832 68.86L103.421 69.7464L12.6674 29.5753L14.2496 25.866Z",
    fill: "#979494"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1247_4667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174,
    height: 139,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortGoalsPlaceholder);
export default __webpack_public_path__ + "static/media/ShortGoalsPlaceholder.b11f2a18fcfaa0c782bf24d941bc0875.svg";
export { ForwardRef as ReactComponent };